import { Col, Row } from "antd"

import { authStore } from "@src/app/authStore"
import { EmptyLayoutWithLogout } from "@src/app/layouts/EmptyLayoutWithLogout"
import UiStore from "@src/app/uiStore"
import { GenerateKYBLink } from "@src/pages/statusConfirmation/ui/GenerateKYBLink"
import { RightSideTransferIo } from "@src/pages/statusConfirmation/ui/RightSideTransferIo"
import { TryTestEnvironment } from "@src/pages/statusConfirmation/ui/TryTestEnvironment"
import css from "./index.module.css"

export const StatusConfirmation = () => {
  const { merchant } = authStore

  return (
    <EmptyLayoutWithLogout>
      <>
        {merchant && (
          <Row align="middle" className={css.card}>
            <Col
              className={css.tryTestCol}
              lg={15}
              span={24}
              style={{ display: "flex" }}
            >
              <TryTestEnvironment email={merchant.email} />
            </Col>
            <Col
              className={css.kybCol}
              lg={9}
              span={24}
              style={{ display: "flex" }}
            >
              {UiStore().isTransferioTheme ? (
                <RightSideTransferIo />
              ) : (
                <GenerateKYBLink />
              )}
            </Col>
          </Row>
        )}
      </>
    </EmptyLayoutWithLogout>
  )
}
